<style lang="scss">
@import '@/styles/variables.scss';
</style>

<template>

    <!-- Application container -->
    <!-- Contains all the components of the application -->
    <router-view id="app" class="app-container" />

</template>

<script>
export default {
	name: 'App'
}
</script>